import React from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import i18 from '../../../i18'
import api from '../../../source/api'
import PATH from '../../../config/dev'
import NotificationSystem from 'react-notification-system'
import {Link} from 'react-router-dom'

class DownloadXml extends Reflux.Component {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            company: props.company,
            invoices: props.invoices,

            transferDownloadButtonClicked: false,
            cashDownloadButtonClicked: false,
            insuficientcredit: false,
            enableModuleLog: true,
        }
        this.store = Store
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            company: nextProps.company,
            invoices: nextProps.invoices,
        })
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
        this._notificationSystem = this.refs.notificationSystem
    }

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    download = type => {
        document.body.classList.toggle('loading-body', true);

        let data = {
            type: type,
            company_id: this.state.company.id,
            enableModuleLog: this.state.enableModuleLog,
            invoices: this.state.invoices,
        }


        api.post({url: 'customer/steps/download', data: data}, true)
            .then((response) => {

                if (!response.data.url) {
                    this.setState({insuficientcredit: true})
                    return;
                }

                if (type === 'transfer') {
                    this.setState({transferDownloadButtonClicked: true})
                }
                if (type === 'cash') {
                    this.setState({cashDownloadButtonClicked: true})
                }

                for (let index in response.data.url) {
                    let delay = parseInt(index) * 1000 + 1000;
                    let url = PATH.ENDPOINT_BASE_URL + 'customer/xml/get'
                        + '?auth_token=' + api.getToken()
                        + '&company_id=' + this.state.company.id
                        + '&name=' + response.data.url[index];

                    setTimeout(function () {
                        window.open(url);
                    }, delay);
                }

            })
            .catch((err) => {
                console.log(err);
                this._addNotification(err.response ? err.response.data.error.message : 'Hiba', 'error');
            })
            .finally(function () {
                document.body.classList.remove('loading-body')
            });

        this.setState({enableModuleLog: false});
    }

    render() {
        return (
            <section id='customer-assignment'>
                <div className='col-12'>
                    <br/>
                    <br/>
                    <h4>{i18.COMMON._processedSuccessfully}</h4>
                    <br/>
                    <div className={!this.state.insuficientcredit ? 'text-center' : 'd-none'}>
                        {!this.state.transferDownloadButtonClicked
                            ? <a onClick={(type) => this.download('transfer')} className='green-btn uppercase'>{i18.BUTTONS._downloadOutputFileBank}</a>
                            : <a className='green-btn uppercase disabled'>{i18.BUTTONS._downloadOutputFileBank}</a>
                        }&nbsp;&nbsp;
                        {!this.state.cashDownloadButtonClicked
                            ? <a onClick={(type) => this.download('cash')} className='green-btn uppercase'>{i18.BUTTONS._downloadOutputFileCash}</a>
                            : <a className='green-btn uppercase disabled'>{i18.BUTTONS._downloadOutputFileCash}</a>
                        }
                        <div>
                            <br/>
                            <br/>
                            {this.state.transferDownloadButtonClicked || this.state.cashDownloadButtonClicked ? <Link to="/">Új feldolgozás indítása</Link> : ''}
                        </div>
                    </div>
                    <div className={this.state.insuficientcredit ? 'text-center' : 'd-none'}>
                        <h1>Önnek nincs elegendő egyenlege a kimeneti fájlok letöltéséhez. <br/> Kérjük töltse fel egyenlegét.</h1>
                        <div className='text-center margin-top-30'>
                            <Link to='/payment-start' className='green-btn uppercase'>Egyenleg feltöltése</Link>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <NotificationSystem ref='notificationSystem'/>
                </div>
            </section>
        )
    }
}

export default DownloadXml


// WEBPACK FOOTER //
// ./src/components/customer/steps/downloadxml.js